import type {Editor} from 'grapesjs';
import {AUTO_WIDTH_CTA_CLASS} from '@EmailMakerReact/email-maker-react.constants';
import {EmailMakerCanvasDevice} from '@EmailMakerReact/email-maker-react.types';

// `.pmw-responsive-cell` is included for old-template cleanup but not re-set; `.auto-width-cta` is handled separately by setMobileRule.
const OLD_TEMPLATE_CLEANUP_SELECTORS: string[] = [
  '.pmw-responsive-table .pmw-responsive-cell',
  '.pmw-responsive-cell',
  '.pmw-responsive-table',
  '.pmw-content-container',
  '.pmw-media-type',
  '.pmw-content-button',
];

/** Installs the mobile-responsive CSS rules; selectors are serialized into saved templates so their values are frozen. */
export function addCssRules(editor: Editor, idEmailTemplate: string | null): void {
  const css = editor.Css;
  const isNewTemplate = !idEmailTemplate;
  const mobileMediaWidth: string | undefined = editor.Devices.get(EmailMakerCanvasDevice.MOBILE)?.getWidthMedia();

  if (isNewTemplate) {
    css.clear();
  } else {
    OLD_TEMPLATE_CLEANUP_SELECTORS.forEach((selector) => {
      css.remove(selector);
    });
  }

  if (!mobileMediaWidth) {
    return;
  }

  const setMobileRule = (selector: string, style: Record<string, string>): void => {
    css.setRule(selector, style, {
      atRuleType: 'media',
      atRuleParams: `screen and (max-width: ${mobileMediaWidth})`,
    });
  };

  setMobileRule('.pmw-responsive-table .pmw-responsive-cell', {
    width: '100% !important',
    display: 'block',
  });

  setMobileRule(`.${AUTO_WIDTH_CTA_CLASS}`, {
    display: 'table !important',
  });

  setMobileRule('.pmw-responsive-table', {
    'min-height': '10px !important',
  });

  setMobileRule('.pmw-content-container', {
    width: '100% !important',
  });

  setMobileRule('.pmw-media-type', {
    width: '100% !important',
  });

  setMobileRule('.pmw-content-button', {
    'min-width': 'fit-content !important',
  });
}
